<template>
    <footer class="section footer-area footer-bg">
        <!-- Footer Top -->
        <div class="footer-top ptb_100">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Logo -->
                            <a class="navbar-brand" href="#">
                                <img class="logo" src="assets/img/whiteLogo.png" alt="">
                            </a>
                            <p class="text-white-50 mt-2 mb-3">Looking for tips and answers to rule questions? Follow us on social media for news, updates, giveaways and more </p>
                            <!-- Social Icons -->
                            <div class="social-icons d-flex">
                                <a href="https://twitter.com/ByRuleApp">
                                    <i class="fab fa-twitter"></i>
                                    <i class="fab fa-twitter"></i>
                                </a>
                                <a href="https://www.instagram.com/byruleapp/">
                                    <i class="fab fa-instagram"></i>
                                    <i class="fab fa-instagram"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Footer Title -->
                            <h3 class="footer-title text-white mb-2">About</h3>
                            <ul>
                                <li class="py-2"><a class="text-white-50" href="https://byruleprivacypolicy.web.app/" target="_blank" >Privacy Policy</a></li>
                                <li class="py-2"><a class="text-white-50" href="https://byruleterms.web.app" target="_blank" >Terms &amp; Conditions</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Footer Bottom -->
        <div class="footer-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <!-- Copyright Area -->
                        <div class="copyright-area d-flex flex-wrap justify-content-center justify-content-sm-between text-center py-4">
                            <!-- Copyright Left -->
                            <div class="copyright-left text-white-50">&copy; Copyrights 2020 By Rule All rights reserved.</div>
                            <!-- Copyright Right -->
                            <!-- <div class="copyright-right text-white-50">Made with <i class="icofont-heart-alt"></i> By <a class="text-white-50" href="#">Theme Land</a></div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>